// PORTUGUÊS

export default {
    values: {
        'PROPERTY VALUE': 'VALOR DA PROPRIEDADE',
        'PROPERTY NAME': 'NOME DA PROPRIEDADE',
        'Choose an environment property for your LIVE applications': 'Escolha uma propriedade de ambiente para seus aplicativos LIVE',
        'Environment properties': 'Propriedades do ambiente',
        'Environment properties settings': 'Configurações de propriedades de ambiente',
        'New propriedade': 'Nova propriedade',
        'Property name': 'Nome da propriedade',
        'Property value': 'Valor da propriedade',
        'Environment properties have been saved.': 'Propriedades de ambiente foram salvas com sucesso.',
        'After changing the value of the property, you need to': 'Após alterar o valor da propriedade, é necessário',
        ' restart the plugin ': ' reiniciar o plugin ',
        'that uses it.': 'que a utiliza.'
    }
}
